import { useQuery } from '@tanstack/react-query';
import { hourMs } from 'components/date_time/time';
import { sdClient } from 'contexts/SDKClientContext';
import { queryClient } from 'utils/query';

export const currentUserInfoQueryKey = 'current-user';

export function invalidateCurrentUser() {
    queryClient.invalidateQueries({
        queryKey: [currentUserInfoQueryKey],
    });
}

export function useCurrentUserInfo() {
    return useQuery({
        queryKey: [currentUserInfoQueryKey],
        queryFn: () => sdClient.getCurrentUser({}),
        staleTime: hourMs,
    });
}
